import { motion } from "framer-motion";
import clsx from "clsx";
import { shadowAndBorderClass } from "screens/Dashboard/utils/classes";

export const InfoBlock = ({ label, text }: { label: string; text: string }) => {
  return (
    <motion.div
      className={clsx(
        "relative flex flex-col justify-center items-center gap-[4px] max-lg:gap-[5px] py-[8px] max-lg:py-[8px] w-full rounded-[16px] max-lg:rounded-[12px] before:!rounded-[16px] max-lg:before:!rounded-[12px] bg-[#161616]",
        shadowAndBorderClass
      )}
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <p className="font-luxora-regular text-white/40 text-[12px] max-lg:text-[12px] leading-[120%]">
        {label}
      </p>
      <p className="text-white font-luxora-medium text-[20px] max-lg:text-[18px] leading-[110%]">
        {text}
      </p>
    </motion.div>
  );
};
